/* jareko-variants.js — JarekopaiT Premium Variant Selector v2.1
   Detecta tipo de variante (color/tamaño/modelo) y enriquece visualmente.
   NO modifica la lógica de Shopify: solo agrega clases, swatches y el valor
   seleccionado en la leyenda. */
(function () {
  'use strict';

  var PALETTE = {
    'verde':'#5CB85C','celeste':'#4FC3F7','rosa':'#F48FB1','rojo':'#EF5350',
    'azul':'#42A5F5','negro':'#212121','blanco':'#FFFFFF','amarillo':'#FFCA28',
    'naranja':'#FFA726','morado':'#AB47BC','violeta':'#7E57C2','gris':'#9E9E9E',
    'beige':'#F5E6D3','marron':'#795548','cafe':'#795548','turquesa':'#26C6DA',
    'dorado':'#FFD700','plateado':'#BDBDBD','coral':'#FF7043','salmon':'#EF9A9A',
    'lila':'#CE93D8','fucsia':'#E91E63','crema':'#FFF9C4','champan':'#F7E7CE',
    'bordeaux':'#5E1A24','bordo':'#5E1A24','burdeos':'#5E1A24','vino':'#722F37',
    'arcoiris':'#AB47BC','rosa fuerte':'#E91E63','celeste claro':'#B3E5FC','verde agua':'#80CBC4',
    'red':'#EF5350','blue':'#42A5F5','green':'#5CB85C','black':'#212121',
    'white':'#FFFFFF','yellow':'#FFCA28','orange':'#FFA726','purple':'#AB47BC',
    'pink':'#F48FB1','gray':'#9E9E9E','grey':'#9E9E9E','gold':'#FFD700',
    'silver':'#BDBDBD','brown':'#795548','navy':'#1A237E','sky':'#4FC3F7',
    'teal':'#00BCD4','mint':'#A5D6A7','lavender':'#E1BEE7','cream':'#FFF9C4',
    'rose':'#F48FB1','turquoise':'#26C6DA','peach':'#FFCCBC','ivory':'#FFFFF0'
  };

  var LIGHT = ['#FFFFFF','#FFF9C4','#FFFFF0','#F5E6D3','#F7E7CE','#FFCCBC','#E1BEE7','#FFD700','#BDBDBD','#B3E5FC','#A5D6A7'];

  var MEASURE_RE = /\d+\s*(cm|mm|m|mts?|l|lt|lts|litros?|ml|kg|g|gr|w|v|niveles?|pulgadas?|pulg|in|")\b/i;

  function norm(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function getColor(name) {
    var k = norm(name);
    if (PALETTE[k]) return PALETTE[k];
    var first = k.split(/[\s\/\-_]+/)[0];
    return PALETTE[first] || null;
  }

  function isColorGroup(t) {
    var n = norm(t);
    return n.indexOf('color') === 0 || n === 'colour' || n === 'colores';
  }

  function isSizeGroup(t) {
    var n = norm(t);
    return ['talla','tamano','size','medida','taille','capacidad','litros','pulgadas','ancho','alto','largo','altura','longitud','profundidad','diametro','nivel','peso'].some(function (k) {
      return n.indexOf(k) !== -1;
    });
  }

  function getLabelText(label) {
    return Array.prototype.filter.call(label.childNodes, function (n) {
      return n.nodeType === 3 ||
        (n.nodeType === 1 && !n.classList.contains('visually-hidden') && !n.classList.contains('jk-swatch'));
    }).map(function (n) { return n.textContent.trim(); }).join('').trim();
  }

  /* Fallback: si la mayoría de los valores parecen medidas (65 CM, 2L, 5 niveles…) es tamaño */
  function valuesLookLikeSizes(fs) {
    var labels = fs.querySelectorAll('label');
    if (!labels.length) return false;
    var hits = 0;
    Array.prototype.forEach.call(labels, function (l) {
      if (MEASURE_RE.test(getLabelText(l))) hits++;
    });
    return hits >= Math.ceil(labels.length / 2);
  }

  function updateLegend(fs) {
    var legend = fs.querySelector('legend');
    if (!legend) return;
    var checked = fs.querySelector("input[type='radio']:checked");
    if (!checked) return;
    var label = fs.querySelector("label[for='" + checked.id + "']");
    var text = label ? getLabelText(label) : checked.value;
    var span = legend.querySelector('.jk-val');
    if (!span) {
      span = document.createElement('span');
      span.className = 'jk-val';
      legend.appendChild(span);
    }
    span.textContent = text;
  }

  function enhance() {
    var fieldsets = document.querySelectorAll('#MainContent .product-form__input--pill');
    Array.prototype.forEach.call(fieldsets, function (fs) {
      var legend = fs.querySelector('legend, .form__label');
      if (!legend) return;
      var legendText = (legend.childNodes[0] ? legend.childNodes[0].textContent : legend.textContent).trim();

      if (!fs.dataset.jkDone) {
        if (isColorGroup(legendText)) {
          fs.classList.add('jk-color');
        } else if (isSizeGroup(legendText) || valuesLookLikeSizes(fs)) {
          fs.classList.add('jk-size');
        } else {
          fs.classList.add('jk-model');
        }
        fs.dataset.jkDone = '1';
      }

      if (fs.classList.contains('jk-color')) {
        Array.prototype.forEach.call(fs.querySelectorAll('label'), function (label) {
          if (label.querySelector('.jk-swatch')) return;
          var text = getLabelText(label);
          var css = getColor(text);
          if (css) {
            var dot = document.createElement('span');
            dot.className = 'jk-swatch' + (LIGHT.indexOf(css.toUpperCase()) !== -1 ? ' jk-swatch-light' : '');
            dot.style.backgroundColor = css;
            dot.setAttribute('aria-hidden', 'true');
            label.insertBefore(dot, label.firstChild);
          }
        });
      }

      updateLegend(fs);
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio') return;
    var fs = e.target.closest ? e.target.closest('.product-form__input--pill') : null;
    if (fs) updateLegend(fs);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length && document.querySelector('#MainContent .product-form__input--pill')) {
        setTimeout(enhance, 80);
        break;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

})();
